import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B080050FindRequest = { shukashijiYmd: string } & Partial<{
  shijikaisu: string;
  batchNo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  shohinCd: string;
  janCd: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B080050FindResponse = {
  locationCd: string;
  tokuiCdNonyuCd: string;
  tokuiNmr: string;
  shohinCdJanCd: string;
  shohinNm: string;
  juchudenpyoNo: string;
  shukayoteisu: string;
  keppinriyuCd: string;
  keppinriyuNm: string;
  shukajokyo: string;
  juchuYmd: string;
  juchugyoNo: string;
  juchukoseigyoNo: string;
  version: string;
};

//検索処理
export const B080050Find = (props: B080050FindRequest) => {
  return RestClient.get<PageableResponse<B080050FindResponse[]>>(
    "b080050/find",
    {
      params: props,
    }
  );
};

export type B080050UpdateField = {
  juchuYmd: string;
  juchudenpyoNo: string;
  juchugyoNo: string;
  juchukoseigyoNo: string;
  locationCd: string;
  shukayoteisu: string;
  shukakakuteisu: string;
  version: string;
} & Partial<{ keppinriyuCd: string; keppinriyuNm: string }>;

export type B080050UpdateRequest = Partial<{
  b080050UpdateFieldList: B080050UpdateField[];
}>;

//更新処理
export const B080050Update = (props: B080050UpdateRequest) => {
  return RestClient.put("b080050/update", props);
};
